import { useCallback, useState } from "react"
import { Typography, LinearProgress, Box } from "@mui/material"
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline"
import { Accept, useDropzone } from "react-dropzone"

import Modal from "shared/Modal"
import { toast } from "react-toastify"
import { DragAccept, DragActive, DragReject, UploadButton, Dropzone as Drop } from "./styles"
import { productService } from "services/productService"

interface IModalEditMany {
  isOpen: boolean
  setIsOpen: (value: boolean) => void
  getSkus: () => Promise<void>
}

export const DialogUpload = ({ isOpen, setIsOpen, getSkus }: IModalEditMany) => {
  const [file, setFile] = useState<FormData | null>(null)
  const [isUploading, setIsUploading] = useState<boolean>(false)
  const [fileName, setFileName] = useState("")
  const [isLoading, setIsLoading] = useState(false)

  const onDropAccepted = useCallback((acceptedFiles: any[]) => {
    try {
      setIsUploading(true)
      const uploadedFile = acceptedFiles[0]
      setFileName(uploadedFile?.name)
      const formData = new FormData()
      formData.append("file", uploadedFile)
      setFile(formData)
    } finally {
      setIsUploading(false)
    }
  }, [])

  const handleCloseDialog = () => {
    setIsOpen(false)
    setIsLoading(false)
    setIsUploading(false)
    setFile(null)
    setFileName("")
  }

  const handleUpdateSkus = async () => {
    if (!file) return

    try {
      setIsLoading(true)
      toast("Upload iniciado, aguarde...", { type: "info" })
      await productService.patchUploadExcelProduct(file, fileName)
      setTimeout(async () => {
        toast("Upload realizado com sucesso!", { type: "success" })
        handleCloseDialog()
        await getSkus()
      }, 2000)
    } catch (error: any) {
      const errorMessage = error?.message || error?.msg
      toast(errorMessage ?? "Eita, deu ruim, dá um alô pro time de tech.", { type: "error" })
      setIsLoading(false)
    }
  }

  const { getRootProps, getInputProps, isDragAccept, isDragActive, isDragReject } = useDropzone({
    onDropAccepted,
    accept: ".xlsx, .xls, .xml, .csv" as unknown as Accept,
  })

  return (
    <Modal
      title="Alteração em massa para SKUs"
      open={isOpen}
      handleClose={handleCloseDialog}
      style={{ width: "40rem", borderRadius: "1rem" }}
    >
      <Box>
        <Typography>
          O Arquivo deve ser em excel, a primeira linha de cada coluna deve conter um título
          qualquer e os dados iniciando na 2° linha, seguindo a ordem das seguintes colunas:
        </Typography>
        <br />
        <Typography>Coluna A: Número do SKU</Typography>
        <Typography>Coluna B: Limite máximo inferior (un)</Typography>
      </Box>

      <Drop
        {...getRootProps({
          className: `${isDragActive && DragActive} ${isDragAccept && DragAccept} ${isDragReject && DragReject}`,
        })}
      >
        <input {...getInputProps()} disabled={isUploading} />
        {isUploading === true ? (
          <Typography style={{ display: "flex", gap: 10 }}>
            <CheckCircleOutlineIcon />
            Arquivo enviado com sucesso
          </Typography>
        ) : isDragReject ? (
          <Typography>O tipo desse arquivo não é aceito</Typography>
        ) : (
          <Typography>
            {fileName === ""
              ? "Arrasta o arquivo de excel pra cá ou clica aqui pra buscar ele"
              : fileName}
          </Typography>
        )}
      </Drop>

      <Box sx={{ marginTop: "25px" }}>
        {isUploading ? (
          <LinearProgress variant="buffer" value={100} valueBuffer={100} />
        ) : (
          <UploadButton
            variant="contained"
            onClick={handleUpdateSkus}
            disabled={isLoading || isUploading || fileName === ""}
          >
            {isLoading ? "Enviando, aguarde..." : "Enviar"}
          </UploadButton>
        )}
      </Box>
    </Modal>
  )
}
